import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { BLOG_POSTS_DATA } from '../blogData';

// Normalize admin/backend blog shape to the legacy frontend shape used by
// the BlogPosts list and BlogPost page (camelCase keys + content).
function normalizeBlog(b) {
  return {
    id: b.id,
    slug: b.slug,
    title: b.title,
    excerpt: b.excerpt || '',
    image: b.image || '',
    imageAlt: b.image_alt || b.imageAlt || b.title,
    category: b.category || '',
    readTime: b.read_time || b.readTime || '',
    publishedAt: b.published_at || b.publishedAt || '',
    keywords: b.keywords || [],
    relatedSlugs: b.related_slugs || b.relatedSlugs || [],
    content: b.content || [],
  };
}

export function useBlogs() {
  const [data, setData] = useState(BLOG_POSTS_DATA);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancel = false;
    api.getBlogs()
      .then((list) => {
        if (cancel) return;
        if (Array.isArray(list) && list.length > 0) setData(list.map(normalizeBlog));
      })
      .catch(() => {})
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, []);
  return { data, loading };
}

export function useBlogBySlug(slug) {
  const [post, setPost] = useState(() => BLOG_POSTS_DATA.find((p) => p.slug === slug) || null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancel = false;
    setLoading(true);
    api.getBlogBySlug(slug)
      .then((b) => { if (!cancel && b) setPost(normalizeBlog(b)); })
      .catch((err) => {
        if (cancel) return;
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`useBlogBySlug('${slug}') falling back to mock`, err);
        }
        setPost(BLOG_POSTS_DATA.find((p) => p.slug === slug) || null);
      })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [slug]);
  return { post, loading };
}
